import { motion } from "framer-motion";
import { EASE } from "./shared";

const WAVE_D =
  "M 0.0 7.6 L 16.0 7.8 L 17.5 7.8 L 19.0 7.8 L 20.5 7.8 L 22.0 7.9 L 23.5 8.0 L 25.0 8.1 L 26.5 8.2 L 28.0 8.4 L 29.5 8.6 L 31.0 8.9 L 32.5 9.1 L 34.0 9.5 L 35.5 9.8 L 37.0 10.2 L 38.5 10.5 L 40.0 10.9 L 41.5 11.1 L 43.0 11.5 L 44.5 11.9 L 46.0 12.1 L 47.5 12.4 L 49.0 12.7 L 50.5 12.9 L 52.0 13.1 L 53.5 13.2 L 55.0 13.3 L 56.5 13.4 L 58.0 13.5 L 59.5 13.5 L 61.0 13.5 L 62.5 13.5 L 64.0 13.4 L 65.5 13.2 L 67.0 13.2 L 68.5 13.0 L 70.0 12.8 L 71.5 12.5 L 73.0 12.3 L 74.5 12.0 L 76.0 11.7 L 77.5 11.4 L 79.0 11.1 L 80.5 10.8 L 82.0 10.5 L 83.5 10.2 L 85.0 9.9 L 86.5 9.6 L 88.0 9.4 L 89.5 9.2 L 91.0 9.0 L 92.5 8.8 L 94.0 8.6 L 95.5 8.4 L 97.0 8.2 L 98.5 8.2 L 100.0 8.2 L 101.5 8.2 L 103.0 8.2 L 104.5 8.2 L 106.0 8.2 L 107.5 8.2 L 109.0 8.3 L 110.5 8.5 L 112.0 8.7 L 113.5 8.8 L 115.0 9.0 L 116.5 9.2 L 118.0 9.4 L 119.5 9.6 L 121.0 9.9 L 122.5 10.1 L 124.0 10.4 L 125.5 10.6 L 127.0 10.9 L 128.5 11.1 L 130.0 11.5 L 131.5 11.8 L 133.0 12.0 L 134.5 12.2 L 136.0 12.5 L 137.5 12.9 L 139.0 13.1 L 140.5 13.4 L 142.0 13.6 L 143.5 14.0 L 145.0 14.2 L 146.5 14.3 L 148.0 14.5 L 149.5 14.8 L 151.0 14.8 L 152.5 14.9 L 154.0 15.1 L 155.5 15.2 L 157.0 15.2 L 158.5 15.2 L 160.0 15.1 L 161.5 15.0 L 163.0 15.0 L 164.5 14.9 L 166.0 14.7 L 167.5 14.5 L 169.0 14.5 L 170.5 14.2 L 172.0 14.0 L 173.5 13.8 L 175.0 13.6 L 176.5 13.4 L 178.0 13.1 L 179.5 12.9 L 181.0 12.5 L 182.5 12.2 L 184.0 11.9 L 185.5 11.5 L 187.0 11.1 L 188.5 10.8 L 190.0 10.4 L 191.5 10.1 L 193.0 9.6 L 194.5 9.1 L 196.0 8.7 L 197.5 8.2 L 199.0 7.8 L 200.5 7.3 L 213.0 6.6";

export const AnimatedLogo = () => (
  <div className="flex flex-col items-center" data-testid="intro-logo">
    <div className="overflow-hidden">
      <motion.img
        src="/assets/villaflow-wordmark.png"
        alt="VillaFlow"
        className="w-[280px] sm:w-[380px]"
        initial={{ y: "70%", opacity: 0 }}
        animate={{ y: "0%", opacity: 1 }}
        transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
      />
    </div>
    <svg viewBox="0 0 213 17" className="-mt-1 w-[267px] sm:w-[362px]" fill="none" aria-hidden="true">
      <motion.path
        d={WAVE_D}
        stroke="#D4AF37"
        strokeWidth={2.2}
        strokeLinecap="round"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.3, delay: 0.75, ease: "easeInOut" }}
      />
    </svg>
    <motion.span
      className="mt-6 font-sans text-[10px] uppercase tracking-[0.42em] text-[#D4AF37]"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 1.7, ease: EASE }}
    >
      Every stay. More value.
    </motion.span>
  </div>
);
